// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"599926c3","239":"6b509add","453":"075ac98c","732":"90ae024d"}[chunkId] + ".chunk.js";
};